export let departamentosJson = './data/departamentos_3857.json',
provinciasJson = './data/provincias_3857.json',
distritosJson = './data/distritos_3857.json',
ccpp01Json = './data/01_3857.json',
ccpp02Json = './data/02_3857.json',
ccpp03Json = './data/03_3857.json',
ccpp04Json = './data/04_3857.json',
ccpp05Json = './data/05_3857.json',
ccpp06Json = './data/06_3857.json',
ccpp07Json = './data/07_3857.json',
ccpp08Json = './data/08_3857.json',
ccpp09Json = './data/09_3857.json',
ccpp10Json = './data/10_3857.json',
ccpp11Json = './data/11_3857.json',
ccpp12Json = './data/12_3857.json',
ccpp13Json = './data/13_3857.json',
ccpp14Json = './data/14_3857.json',
ccpp15Json = './data/15_3857.json',
ccpp16Json = './data/16_3857.json',
ccpp17Json = './data/17_3857.json',
ccpp18Json = './data/18_3857.json',
ccpp19Json = './data/19_3857.json',
ccpp20Json = './data/20_3857.json',
ccpp21Json = './data/21_3857.json',
ccpp22Json = './data/22_3857.json',
ccpp23Json = './data/23_3857.json',
ccpp24Json = './data/24_3857.json',
ccpp25Json = './data/25_3857.json';

export const BASE_HOST = 'https://geosdot.servicios.gob.pe';
//export const BASE_HOST = 'http://192.168.71.61:8080';

// Contexto del GeoServer
export const GEOSERVER_CTX = '/geoserver/geoportal';

// Helper para evitar dobles barras
const trimRightSlash = (s) => s.replace(/\/+$/, '');

// Derivados
export const GEOSERVER_BASE = `${trimRightSlash(BASE_HOST)}${GEOSERVER_CTX}`;
export const urlLegend = `${GEOSERVER_BASE}/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image/png&width=20&height=20&layer=`;

export const urlWMS = `${GEOSERVER_BASE}/wms?`,
urlWFS = `${GEOSERVER_BASE}/wfs?`,
markers = './assets/images/icon-green50.png',
centroid3857 = [-8277259.790554121,-1033993.6428854751],
extension3857 = [-9056413.683884881,-2078385.7561873442,-7644744.070702932,-4104.90673861339],
enlacesWeb = [
  'https://geosdot.servicios.gob.pe/geoportal/',
  'https://geosdot.servicios.gob.pe/consultas/#/login',
  'https://app.powerbi.com/view?r=eyJrIjoiNGExMzZhZWEtODQ5Zi00NWE1LWI0YzctNWZkNmQ5M2Y1MzcyIiwidCI6IjM0YjQ4ZTRlLTI1MTktNDA2MC1hMDllLTViMDVkOTAxYTRkNyJ9'
], //OMD
//enlacesWeb = [
//  'http://192.168.71.61:5173/geoportal/',
//  'http://192.168.71.61:9090/consultas/',
//  'https://app.powerbi.com/view?r=eyJrIjoiNGExMzZhZWEtODQ5Zi00NWE1LWI0YzctNWZkNmQ5M2Y1MzcyIiwidCI6IjM0YjQ4ZTRlLTI1MTktNDA2MC1hMDllLTViMDVkOTAxYTRkNyJ9'
//], //OMD
keyBingMap = 'AhoBzwdjV8QbzFYkcGem-IjwJexWX7HL-G3vc7d31dxhW21xzDJEG8n9v4VDvfB_',
proyeccion3857 = 'EPSG:3857',
proyeccion4326 = 'EPSG:4326',
proyeccion32717 = 'EPSG:32717',
proyeccion32718 = 'EPSG:32718',
proyeccion32719 = 'EPSG:32719',
formatoImagen = 'image/png',
versionWMS = '1.3.0',
versionWFS = '1.1.0',
exepcion = 'application/vnd.ogc.se_inimage',
formatoSalidaJson = 'application/json',
formatoSalidaGeoJson = 'application/geojson',
nombresColumnas = [
  {id: 'cat_tiempo', nombre: 'Rango de tiempo'},

  {id: 'rango', nombre: 'Rango'}, //OMD
  {id: 'nivel', nombre: 'Nivel'}, //OMD

  {id: 'ubigeo', nombre: 'Ubigeo'},
  {id: 'nombdep', nombre: 'Departamento'}, //OMD
  {id: 'nombprov', nombre: 'Provincia'}, //OMD
  {id: 'nombdist', nombre: 'Distrito'}, //OMD
  {id: 'codccpp', nombre: 'Código Censal'}, //OMD
  {id: 'cen_pob', nombre: 'Nombre del centro poblado'}, //OMD
  {id: 'pob', nombre: 'Población 2017'},
  {id: 'viv', nombre: 'Viviendas 2017'},
  {id: 'fuente', nombre: 'Fuente'}, //OMD
  {id: 'capital', nombre: 'Es capital'},
  {id: 'vab_total', nombre: 'VAB estimado'}, //OMD
  {id: 'departamen', nombre: 'Departamento'}, //OMD

  //{id: 'cenpob_ren', nombre: 'Centro poblado'},
  {id: 'codcp_inei', nombre: 'Código CCPP censal'},
  {id: 'inst', nombre: 'Instrumento'},
  {id: 'tipo_accio', nombre: 'Acción'},
  {id: 'categoria', nombre: 'Categoría'},
  {id: 'direccion', nombre: 'Documento'}, //OMD
  {id: 'nombdpto', nombre: 'Departamento'}, //OMD

  {id: 'trayectori', nombre: 'Trayecto'},
  {id: 'nrocarril', nombre: 'Número de carril'},
  {id: 'ejeclas', nombre: 'Clase'},
  {id: 'codruta', nombre: 'Código ruta'},
  {id: 'jerarq', nombre: 'Jerarquía'},
  {id: 'superfic_l', nombre: 'Tipo superficie'},
  {id: 'estado_l', nombre: 'Estado'},

  {id: 'label', nombre: 'Nombre'},
  {id: 'tipo', nombre: 'Tipo'},
  {id: 'escala', nombre: 'Escala'},

  {id: 'NOMCOM', nombre: 'Nombre de la comunidad'},
  {id: 'DEPAR', nombre: 'Departamento'},
  {id: 'PROVI', nombre: 'Provincia'},
  {id: 'DISTR', nombre: 'Distrito'},

  {id: 'nom_dep', nombre: 'Departamento'},
  {id: 'nom_cuenca', nombre: 'Cuenca'},
  {id: 'nomb_rio_q', nombre: 'Río/Quebrada'},
  {id: 'tipo_ficha', nombre: 'Tipo'},
  {id: 'nom_dpto', nombre: 'Departamento'},

  {id: 'nom_prov', nombre: 'Provincia'},
  {id: 'nom_dist', nombre: 'Distrito'},
  {id: 'observ', nombre: 'Observación'},

  {id: 'nombre', nombre: 'Nombre'},
  {id: 'anio', nombre: 'Año de publicación'},
  {id: 'descripcio', nombre: 'Descripción'},
  {id: 'url', nombre: 'Documento'},
  {id: 'url1', nombre: 'Anexo'},
  {id: 'estado', nombre: 'Estado'},
  {id: 'ambito', nombre: 'Ubicación'},
  {id: 'autor_corp', nombre: 'Fuente'},

  {id: 'fecha', nombre: 'Fecha'},
  {id: 'fecha_fin', nombre: 'Fecha'},
  {id: 'fecha_doc', nombre: 'Fecha del documento'}, //OMD
  {id: 'fecha_inst', nombre: 'Fecha del instrumento'}, //OMD
  
  {id: 'paraje', nombre: 'Paraje'}, //OMD
  {id: 'nombre_ent', nombre: 'Fuente'}, //OMD
  {id: 'nom_rio_q', nombre: 'Río/Quebrada'}, //OMD

  {id: 'medid_prev', nombre: 'Medidas preventivas'}, //OMD

  {id: 'tip_peligro', nombre: 'Tipo de peligro'}, //OMD
  {id: 'peligro_esp', nombre: 'Peligro'}, //OMD

  {id: 'nom_predio', nombre: 'Nombre del predio'}, //OMD
  {id: 'part_regis', nombre: 'Partida registral'}, //OMD
  {id: 'n_peligro', nombre: 'Nivel de peligro'}, //OMD
  {id: 'nom_lugar', nombre: 'Lugar'}, //OMD
  {id: 'nom_rio', nombre: 'Nombre del río'}, //OMD
  
  {id: 'des_inu', nombre: 'Descripción'}, //OMD
  {id: 'tipo_inu2', nombre: 'Inundación por su origen'}, //OMD
  {id: 'tip_peligr', nombre: 'Tipo de peligro'}, //OMD
  {id: 'peligro_es', nombre: 'Peligro'}, //OMD
  {id: 'descrip', nombre: 'Descripción'}, //OMD
  {id: 'tipo_pel', nombre: 'Peligro'}, //OMD
  {id: 'e_expuesto', nombre: 'Elementos expuestos'}, //OMD
  {id: 'recomend', nombre: 'Recomendaciones'}, //OMD

  //{id: 'infraestru', nombre: 'Infraestructura'}, //OMD
  {id: 'fecha_actu', nombre: 'Actualización'}, //OMD
  {id: 'url_documento', nombre: 'Documento'}, //OMD
  {id: 'nombre_entidad', nombre: 'Fuente'}, //OMD
  {id: 'departamento', nombre: 'Departamento'}, //OMD
  {id: 'provincia', nombre: 'Provincia'}, //OMD
  {id: 'distrito', nombre: 'Distrito'}, //OMD

  {id: 'CODINST', nombre: 'Código de la IE'}, //OMD
  {id: 'CEN_EDU', nombre: 'Nombre de la IE'}, //OMD
  {id: 'D_DREUGEL', nombre: 'Nombre de la DRE o UGEL'}, //OMD
  {id: 'D_GESTION', nombre: 'Tipo de Gestión'}, //OMD
  {id: 'D_GES_DEP', nombre: 'Dependencia'}, //OMD
  {id: 'D_FORMA', nombre: 'Forma'}, //OMD
  {id: 'COD_MOD', nombre: 'Código modular'}, //OMD
  {id: 'ANEXO', nombre: 'Anexo'}, //OMD
  {id: 'D_NIV_MOD', nombre: 'Nivel/Modalidad'}, //OMD
  {id: 'D_COD_CAR', nombre: 'Característica'}, //OMD
  {id: 'D_TIPSSEXO', nombre: 'Género'}, //OMD
  {id: 'D_TIPOPROG', nombre: 'Tipo de programa'}, //OMD
  {id: 'D_COD_TUR', nombre: 'Turno'}, //OMD

  {id: 'SERVICIOS', nombre: 'Servicio educativo'}, //OMD
  {id: 'DIR_CEN', nombre: 'Dirección'}, //OMD
  {id: 'LOCALIDAD', nombre: 'Localidad'}, //OMD
  {id: 'CEN_POB', nombre: 'Centro Poblado'}, //OMD
  {id: 'D_DPTO', nombre: 'Departamento'}, //OMD
  {id: 'D_PROV', nombre: 'Provincia'}, //OMD
  {id: 'D_DIST', nombre: 'Distrito'}, //OMD

  {id: 'cod_unic_e', nombre: 'Código IPRESS'},
  {id: 'des_tipo_e', nombre: 'Tipo establecimiento'},
  {id: 'des_clas_e', nombre: 'Clasificación'},
  {id: 'nom_esta', nombre: 'Nombre establecimiento'},
  {id: 'des_inst_d', nombre: 'Institución a la que pertenece'},
  {id: 'dir_esta', nombre: 'Dirección'},
  {id: 'fec_inic_o', nombre: 'Fecha inicio actividad'},
  {id: 'cod_cate', nombre: 'Categoría'},
  {id: 'doc_cate', nombre: 'Resolución categoría'},
  {id: 'cod_cond_e', nombre: 'Condición'},

  {id: 'region_nat', nombre: 'Región natural'},
  {id: 'tipo_norma', nombre: 'Tipo de norma'},
  {id: 'numero', nombre: 'Número'},

  {id: 'valor', nombre: 'Flujo entre distritos'}, //OMD
  //Origen
  {id: 'dep_salen', nombre: 'dep_salen'}, //OMD
  {id: 'prov_salen', nombre: 'prov_salen'}, //OMD
  {id: 'dist_salen', nombre: 'dist_salen'}, //OMD
  //Destino
  {id: 'dep_entran', nombre: 'dep_entran'}, //OMD
  {id: 'prov_entra', nombre: 'prov_entra'}, //OMD
  {id: 'dist_entra', nombre: 'dist_entra'}, //OMD

  {id: 'centro_pob', nombre: 'Centro Poblado'}, //OMD
  {id: 'emoperador', nombre: 'Cantidad de operadores'}, //OMD
  {id: 'layer', nombre: 'Tipo de tecnología'}, //OMD
  
  {id: 'dep', nombre: 'Departamento'}, //OMD
  {id: 'prov', nombre: 'Provincia'}, //OMD
  {id: 'pob_2007', nombre: 'Población 2007'}, //OMD
  {id: 'pob_2017', nombre: 'Población 2017'}, //OMD
  {id: 'tasa', nombre: 'Tasa'}, //OMD
  {id: 'capital', nombre: 'Es capital'}, //OMD
  {id: 'region', nombre: 'Región'}, //OMD

  //{id: 'cod_modu', nombre: 'Código modular'}, //OMD
  //{id: 'cod_nive_m', nombre: 'Código nivel'}, //OMD
  //{id: 'des_cent_e', nombre: 'Insitución educativa'}, //OMD
  //{id: 'des_nive_m', nombre: 'Nivel'}, //OMD
  //{id: 'des_form_a', nombre: 'Tipo'}, //OMD
  //{id: 'des_gest', nombre: 'Gestión'}, //OMD
  //{id: 'des_depe_g', nombre: 'Dependencia'}, //OMD
  //{id: 'nombprov', nombre: 'Provincia'}, //OMD
  //{id: 'nombdist', nombre: 'Distrito'}, //OMD
  //{id: 'UBIDIS', nombre: 'Ubigeo'}, //OMD
  
  //{id: 'cod_partida', nombre: 'Partida'}, //OMD
  //{id: 'des_limite', nombre: 'Límite'}, //OMD
  //{id: 'des_departamento', nombre: 'Departamento'}, //OMD
  //{id: 'des_provincia', nombre: 'Provincia'}, //OMD
  //{id: 'des_libro', nombre: 'Libro'}, //OMD
  //{id: 'des_seccion', nombre: 'Sección'}, //OMD
  //{id: 'tramo', nombre: 'Núm. de tramo'}, //OMD
  //{id: 'des_tipo_norma', nombre: 'Tipo de norma'}, //OMD
  //{id: 'des_numero_norma', nombre: 'Núm. de norma'}, //OMD
  //{id: 'fecha_norma', nombre: 'Fecha de norma'}, //OMD
  //{id: 'rep_cartografica', nombre: 'Repr. cartográf.'}, //OMD
  //{id: 'des_fuente_cartografica', nombre: 'Fuente cartográf.'}, //OMD
  //{id: 'mas_inform', nombre: 'Más información'}, //OMD
  //{id: 'fecha_actualizacion', nombre: 'Actualización'}, //OMD
],
capasTematicas = [
  {id: 'capitales', nombre: 'v_capitales'},
  {id: 'ccppAsentamientosDispersos', nombre: 'ccpp_asentamientos_dispersos'},
  {id: 'tiempoDesplazamientoCapitalCercano', nombre: 'tiempo_deplazamiento_capital_cercano'},
  {id: 'limiteDepartamental', nombre: 'v_departamentos_2023'},
  {id: 'limiteProvincial', nombre: 'v_provincias_2023'},
  {id: 'limiteDistrital', nombre: 'v_distritos_2023'},
  {id: 'ccppCategorizacionRecategorizacion', nombre: 'ccpp_cate_recate'},
  {id: 'ccppReconocimientoLey', nombre: 'ccpp_reconocimiento_ley'},

  {id: 'densidadViviendas', nombre: 'densidad_viviendas'}, //OMD
  {id: 'densidadServiciosFinancieros', nombre: 'densidad_servicio_financiero'}, //OMD
  {id: 'densidadComercio', nombre: 'densidad_comercio'}, //OMD
  {id: 'densidadMercado', nombre: 'densidad_mercado'}, //OMD
  {id: 'densidadInmobiliario', nombre: 'densidad_inmobiliario'}, //OMD
  {id: 'densidadDelitos', nombre: 'densidad_delitos'}, //OMD

  {id: 'densidadCrecimientoPoblacional', nombre: 'densidad_crecimiento_poblacional'}, //OMD
  {id: 'densidadCrecimientoPobCcpp', nombre: 'densidad_crecimiento_pob_ccpp'}, //OMD

  {id: 'vabLima', nombre: 'ccpp150_vab_lima'}, //OMD
  {id: 'vabCallao', nombre: 'ccpp150_vab_callao'}, //OMD
  {id: 'vabTotal', nombre: 'ccpp150_vab_total'}, //OMD
  
  {id: 'coberturaMovOper', nombre: 'cobertura_movil_oper'}, //OMD
  {id: 'coberturaMovTipo', nombre: 'cobertura_movil_tipo'}, //OMD

  {id: 'flujoTrabajo25000', nombre: 'flujo_trb_25000'}, //OMD
  {id: 'flujoTrabajo10000a25000', nombre: 'flujo_trb_10000_25000'}, //OMD
  {id: 'flujoTrabajo5000a10000', nombre: 'flujo_trb_5000_10000'}, //OMD
  {id: 'flujoTrabajo1500a5000', nombre: 'flujo_trb_1500_5000'}, //OMD
  {id: 'flujoTrabajo100a1500', nombre: 'flujo_trb_100_1500'}, //OMD
  {id: 'flujoEstudiantes13000', nombre: 'flujo_est_13000'}, //OMD
  {id: 'flujoEstudiantes7000a13000', nombre: 'flujo_est_7000_13000'}, //OMD
  {id: 'flujoEstudiantes3500a7000', nombre: 'flujo_est_3500_7000'}, //OMD
  {id: 'flujoEstudiantes1000a3500', nombre: 'flujo_est_1000_3500'}, //OMD
  {id: 'flujoEstudiantes100a1000', nombre: 'flujo_est_100_1000'}, //OMD

  {id: 'viasNacional', nombre: 'red_vial_nacional_2022'},
  {id: 'viasDepartamental', nombre: 'red_vial_departamental_2022'},
  {id: 'viasVecinal', nombre: 'red_vial_vecinal_2022'},
  {id: 'aerodromos', nombre: 'aerodromo_2022'}, //OMD
  {id: 'comunidadesNativas', nombre: 'comunidades_nativas'},
  {id: 'comunidadesCampesinas', nombre: 'comunidades_campesinas'},
  {id: 'evaluacionRiesgos', nombre: 'evaluacion_riesgos'},
  {id: 'zonasRiesgosNoMitigable', nombre: 'zonas_riesgos_no_mitigable'},
  {id: 'inventarioInundaciones', nombre: 'inventario_inundaciones'},
  {id: 'tramosCriticosInundaciones', nombre: 'tramos_criticos_inundaciones'},
  {id: 'puntosCriticosInundaciones', nombre: 'puntos_criticos_inundaciones'},
  {id: 'areasExposicionInundaciones', nombre: 'areas_exposicion_inundacion'},
  {id: 'areasExposicionMovimientoMasa', nombre: 'areas_exposicion_movimientos_masa'},
  {id: 'zonasCriticasMovimientoMasa', nombre: 'zonas_criticas_movimientos_masa'},
  {id: 'inventarioMovimientoMasa', nombre: 'inventario_movimientos_masa'},
  {id: 'serviciosEducativos', nombre: 'servicios_educativos'},
  {id: 'localesEducativos', nombre: 'locales_educativos'},
  {id: 'institucionesPrestadorasServiciosSalud', nombre: 'instituciones_prestadoras_servicios_salud'},
];

export function fechaHoy() {
  const fecha = new Date(),
  dia = String(fecha.getDate()).padStart(2, '0'),
  mes = String(fecha.getMonth() + 1).padStart(2, '0'),
  ani = fecha.getFullYear();
  return (dia + '' + mes + '' + ani);
}

export function bbox(id, mensaje, tipo) {
  const alertPlaceholder = document.getElementById(id);
  const texto = '<div class="alert alert-' + tipo + ' alert-dismissible" role="alert">' +
    ' <div>' + mensaje +'</div>' +
    ' <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>' +
    '</div>';
  alertPlaceholder.innerHTML = texto;
}

export function validarURLServicioWMS(url) {
  const regex = /[?&](?=.*\brequest\b)(?=.*\bservice\b)/i;
  return regex.test(url);
}

export function modificarURLServicioWMS(url) {
  if (!/\?/.test(url) || !/(?:[?&])(REQUEST|SERVICE)=/i.test(url)) {
    const parametrosFaltantes = [];
    if (!/(?:[?&])REQUEST=/i.test(url)) {
      parametrosFaltantes.push('REQUEST=GetCapabilities');
    }
    if (!/(?:[?&])SERVICE=/i.test(url)) {
      parametrosFaltantes.push('SERVICE=WMS');
    }
    url += (url.includes('?') ? '&' : '?') + parametrosFaltantes.join('&');
  }
  return url;
}

export function validarUrl(url) {
  try {
    new URL(url);
    return true;
  } catch (error) {
    return false;
  }
}

// OGC: WMS
//https://idesep.senamhi.gob.pe:443/geoserver/g_05_01/wms?
//05_01_001_03_001_512_2021_00_00

//http://34.125.26.195:8080/geoserver/geoportal/wms?

//https://espacialg.geoperu.gob.pe/geoserver/geoperu/wms?service=WMS&request=GetCapabilities&version=1.1.1

// OGC: WFS -- ?service=WFS&version=1.1.0&request=getCapabilities
//https://espacialg.geoperu.gob.pe/geoserver/geoperu/wfs
//peru_caminos_inka_

// Rest ArcGIS
//https://portalgeo.sbn.gob.pe/geosrv/rest/services/sdrc/wms_sinabip_libre/MapServer
//https://geospatial.sernanp.gob.pe/arcgis_server/rest/services/base_fisica/peru_sernanp_010200/MapServer

//https://geominsa.minsa.gob.pe/geominsaserver/rest/services/SRV_DGAIN_DIPOS/SRV_DIPOS_GeoRIS_SeguridadHospitalaria/MapServer